import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import TopicList from '../Components/SubTopic/TopicList'

function SubTopicPage() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          marginLeft: 24,
          marginTop: 24,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <SHeaderbar />
        <div style={{ flex: 1, padding: 0, minHeight: 0 }}>
          <TopicList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default SubTopicPage
